import React from "react";
const NimbusNotFound = () => {
  return (
    <div className="flex flex-col justify-center h-full text-center text-color-raindrop-minor-again gap-6">
      <div>
        <i class="fa-solid fa-triangle-exclamation text-6xl"></i>
      </div>
      <div className="text-4xl font-bold ">Nimbus Not Found</div>
    </div>
  );
};

export default NimbusNotFound;
